import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ANNULUS_SPACES, ANNULUS_FLUID_BASES } from 'mocks/mock-annulus-spaces';
import { CASING_LINER } from 'mocks/mock-casings-liners';
import { CEMENTINGS } from 'mocks/mock-cementing';
import { DIRECTIONAL } from 'mocks/mock-directionals';
import { HANDOVER_TYPES_AREA_REASON } from 'mocks/mock-handover-types-area-reason';
import {
  HANDOVERS,
  HANDOVERS_HISTORY,
  HANDOVERS_TOTAL_COUNT,
  RESULT_HANDOVERS,
} from 'mocks/mock-handovers';
import { IMAGES } from 'mocks/mock-images';
import {
  PRODUCTION_COLUMN_HEADERS,
  PRODUCTION_COLUMNS,
} from 'mocks/mock-production-columns';
import { PROFILES } from 'mocks/mock-profiles';
import { USER_LIDER } from 'mocks/mock-users';
import {
  WELLHEADS,
  WELLHEAD_BOTTOM_CONNECTOR_TYPES,
  WELLHEAD_SECTION_NAMES,
  WELLHEAD_TOP_CONNECTOR_TYPES,
} from 'mocks/mock-wellheads';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { HANDOVER_TYPES } from '../../mocks/mock-handover-types';
import { RESULT_WELLS, WELLS } from '../../mocks/mock-wells';

@Injectable()
export class BackendHttpInterceptor implements HttpInterceptor {
  responses: any = {};

  constructor(private injector: Injector) {
    this.responses[`/dhoapi/handovers/?limit=10&offset=0`] = {
      GET: {
        status: 200,
        body: RESULT_HANDOVERS,
      },
    };
    this.responses['/dhoapi/handover-types'] = {
      GET: { status: 200, body: HANDOVER_TYPES },
    };
    this.responses['/dhoapi/handovers'] = {
      POST: {
        status: 200,
        body: HANDOVERS[0],
      },
    };
    this.responses[`/dhoapi/handovers/${HANDOVERS[0].handoverId}`] = {
      GET: {
        status: 200,
        body: HANDOVERS[0],
      },
    };
    this.responses[`/dhoapi/handovers/${HANDOVERS[0].handoverId}/general`] = {
      GET: {
        status: 200,
        body: WELLS[0],
      },
    };
    this.responses[
      `/dhoapi/handovers/${HANDOVERS[0].handoverId}/casings-liners?wellId=${HANDOVERS[0].wellId}`
    ] = {
      GET: {
        status: 200,
        body: CASING_LINER,
      },
    };
    this.responses[
      `/dhoapi/handovers/${HANDOVERS[0].handoverId}/casings-liners`
    ] = {
      POST: {
        status: 200,
        body: CASING_LINER[0],
      },
    };
    this.responses[
      `/dhoapi/handovers/${HANDOVERS[0].handoverId}/directionals?wellId=${HANDOVERS[0].wellId}`
    ] = {
      GET: {
        status: 200,
        body: DIRECTIONAL,
      },
    };
    this.responses[
      `/dhoapi/handovers/${HANDOVERS[0].handoverId}/profiles?wellId=${HANDOVERS[0].wellId}`
    ] = {
      GET: {
        status: 200,
        body: PROFILES,
      },
    };
    this.responses[`/dhoapi/handovers/${HANDOVERS[0].handoverId}/profiles`] = {
      POST: {
        status: 200,
        body: PROFILES[3],
      },
    };
    this.responses[
      `/dhoapi/wells/?search=ant&limit=10&offset=1&managementUnit=NQN`
    ] = {
      GET: {
        status: 200,
        body: RESULT_WELLS,
      },
    };
    this.responses[
      `/dhoapi/wells/?search=ant&limit=10&offset=2&managementUnit=NQN`
    ] = {
      GET: {
        status: 200,
        body: RESULT_WELLS,
      },
    };
    this.responses[
      `/dhoapi/wells/?search=ant&limit=10&offset=3&managementUnit=NQN`
    ] = {
      GET: {
        status: 200,
        body: RESULT_WELLS,
      },
    };
    this.responses[`/dhoapi/wells/?limit=10&offset=1&managementUnit=NQN`] = {
      GET: {
        status: 200,
        body: RESULT_WELLS,
      },
    };
    this.responses[`/dhoapi/wells/?limit=10&offset=2&managementUnit=NQN`] = {
      GET: {
        status: 200,
        body: RESULT_WELLS,
      },
    };
    this.responses[`/dhoapi/wells/?limit=10&offset=3&managementUnit=NQN`] = {
      GET: {
        status: 200,
        body: RESULT_WELLS,
      },
    };
    this.responses[`../../../../assets/handover-icon-white.svg`] = {
      GET: {
        status: 200,
        body: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 398.8 382.13"><defs><style>.cls-1{fill:#fff;}</style></defs><path class="cls-1" d="M194.14,223.22l17.62-3,60.46-30.82.23-.16a31.61,31.61,0,0,0,7.13-38.38,9.27,9.27,0,0,0,.29-1l3-14.08A41.72,41.72,0,0,0,273.71,100l-27-31.08a41.06,41.06,0,0,0-31.94-14.21l-109.94,2.1L14.14,11.61A8.46,8.46,0,0,0,1.92,19.17V128.58a8.45,8.45,0,0,0,5,7.7l56.5,25.53L74.18,175a87.94,87.94,0,0,0,49.27,30.17l1.08.22.41.1a71,71,0,0,0,14.83,1.57h.33a26.58,26.58,0,0,0,28,13.68l8.17-1.39A24.37,24.37,0,0,0,190,223.58,24.67,24.67,0,0,0,194.14,223.22ZM127,188.68a70.85,70.85,0,0,1-39.34-23.85L75.24,149.59a8.64,8.64,0,0,0-3.07-2.36l-53.35-24.1V32.82L99.14,72.87a9,9,0,0,0,3.92.88l112-2.13h.49A24.18,24.18,0,0,1,234,80l27,31.09a24.67,24.67,0,0,1,5.43,21.12l-1.08,5a31.47,31.47,0,0,0-6.8-2.29l-12.17-2.62,1.29-6a8.44,8.44,0,1,0-16.51-3.55l-1.29,6-8.72-1.87-8-20.26a8.45,8.45,0,0,0-15.72,6.2l3.86,9.78-13.2-2.84a8.45,8.45,0,1,0-3.77,16.47L255,151.44a14.43,14.43,0,0,1-4.78,28.43l-59.24-7.23a8.34,8.34,0,0,0-4.79.83l-5.54,2.75h0a22.15,22.15,0,0,0-4.54,2.27l-12.12,6.05a54.38,54.38,0,0,1-34.9,4.57l-.73-.17Zm55.72,7.48a6.91,6.91,0,0,1,2.12-3.16l6.62-3.3,46.13,1.36-46.36,15.52a7.69,7.69,0,0,1-7.68-3.43A8,8,0,0,1,182.72,196.16ZM161,203.89q2.36-.73,4.67-1.64c.08.59.18,1.18.31,1.76l-.63.11h0A9.81,9.81,0,0,1,161,203.89Z"/><rect class="cls-1" x="280.48" y="292.7" width="69.82" height="17.46"/><rect class="cls-1" x="280.48" y="327.61" width="69.82" height="17.46"/><path class="cls-1" d="M245.57,222.87V362.52A17.44,17.44,0,0,0,262.94,380H367.76a17.52,17.52,0,0,0,17.46-17.46V257.78l-52.37-52.36H263A17.51,17.51,0,0,0,245.57,222.87Zm122.19,43.64v96H263V222.87h61.09v43.64Z"/></svg>',
      },
    };
    this.responses[`../../../../assets/well-schematic-icon.svg`] = {
      GET: {
        status: 200,
        body: '<svg width="21" height="25" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.7012 0H18.7012V5.65H20.7012V0Z" fill="#212B54"/><path d="M13.75 0H11.75V24.24H13.75V0Z" fill="#212B54"/><path d="M17.2305 0H15.2305V13.71H17.2305V0Z" fill="#212B54"/><path d="M2 0H0V5.65H2V0Z" fill="#212B54"/><path d="M8.96094 0H6.96094V24.24H8.96094V0Z" fill="#212B54"/><path d="M5.4707 0H3.4707V13.71H5.4707V0Z" fill="#212B54"/></svg>',
      },
    };
    this.responses['/dhoapi/handover-types-area'] = {
      GET: { status: 200, body: HANDOVER_TYPES_AREA_REASON },
    };
    this.responses[
      `/dhoapi/handovers/${HANDOVERS[0].handoverId}/cementing?wellId=${HANDOVERS[0].wellId}`
    ] = {
      GET: {
        status: 200,
        body: CEMENTINGS,
      },
    };
    this.responses[`/dhoapi/handovers/${HANDOVERS[0].handoverId}/cementing`] = {
      POST: {
        status: 200,
        body: CEMENTINGS[0],
      },
    };
    this.responses[
      `/dhoapi/handovers/${HANDOVERS[0].handoverId}/annulus-spaces?wellId=${HANDOVERS[0].wellId}`
    ] = {
      GET: {
        status: 200,
        body: ANNULUS_SPACES,
      },
    };
    this.responses[
      `/dhoapi/handovers/${HANDOVERS[0].handoverId}/annulus-spaces`
    ] = {
      POST: {
        status: 200,
        body: ANNULUS_SPACES[0],
      },
    };
    this.responses[`/dhoapi/annulus-fluid-bases`] = {
      GET: {
        status: 200,
        body: ANNULUS_FLUID_BASES,
      },
    };
    this.responses[
      `/dhoapi/handovers/${HANDOVERS[0].handoverId}/wellheads?wellId=${HANDOVERS[0].wellId}`
    ] = {
      GET: {
        status: 200,
        body: WELLHEADS,
      },
    };
    this.responses[`/dhoapi/handovers/${HANDOVERS[0].handoverId}/wellheads`] = {
      POST: {
        status: 200,
        body: WELLHEADS[0],
      },
    };
    this.responses[`/dhoapi/wellhead-section-names`] = {
      GET: {
        status: 200,
        body: WELLHEAD_SECTION_NAMES,
      },
    };
    this.responses[`/dhoapi/wellhead-top-connector-types`] = {
      GET: {
        status: 200,
        body: WELLHEAD_TOP_CONNECTOR_TYPES,
      },
    };
    this.responses[`/dhoapi/wellhead-bottom-connector-types`] = {
      GET: {
        status: 200,
        body: WELLHEAD_BOTTOM_CONNECTOR_TYPES,
      },
    };
    this.responses[
      `/dhoapi/handovers/${HANDOVERS[0].handoverId}/wellheads/images`
    ] = {
      GET: {
        status: 200,
        body: IMAGES,
      },
      POST: {
        status: 200,
        body: IMAGES,
      },
      PUT: {
        status: 200,
        body: IMAGES,
      },
    };
    this.responses[
      `/dhoapi/handovers/${HANDOVERS[0].handoverId}/wellheads/images?imageId=${IMAGES[0].imageId}`
    ] = {
      DELETE: {
        status: 200,
        body: true,
      },
    };
    this.responses[
      `/dhoapi/handovers/${HANDOVERS[0].handoverId}/production-column-header?wellId=${HANDOVERS[0].wellId}`
    ] = {
      GET: {
        status: 200,
        body: PRODUCTION_COLUMN_HEADERS,
      },
      POST: {
        status: 200,
        body: PRODUCTION_COLUMN_HEADERS[0],
      },
    };
    this.responses[
      `/dhoapi/handovers/${HANDOVERS[0].handoverId}/production-column?wellId=${HANDOVERS[0].wellId}`
    ] = {
      GET: {
        status: 200,
        body: PRODUCTION_COLUMNS,
      },
      POST: {
        status: 200,
        body: PRODUCTION_COLUMNS[0],
      },
    };
    this.responses[`/dhoapi/handovers/history/${HANDOVERS[0].wellId}`] = {
      GET: {
        status: 200,
        body: HANDOVERS_HISTORY,
      },
    };
    this.responses[
      `/dhoapi/handovers/history/${HANDOVERS[0].wellId}?handoverReturnRows=6`
    ] = {
      GET: {
        status: 200,
        body: HANDOVERS_HISTORY,
      },
    };
    this.responses[`/dhoapi/handovers/search/total-count`] = {
      GET: {
        status: 200,
        body: HANDOVERS_TOTAL_COUNT,
      },
    };
    this.responses[`/dhoapi/user?username='${USER_LIDER.username}'`] = {
      GET: {
        status: 200,
        body: USER_LIDER,
      },
    };
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    console.log(request.url, request.method);
    const matchingResponse = this.responses[request.url][request.method];
    if (matchingResponse) {
      return of(new HttpResponse(matchingResponse)).pipe(delay(1000));
    }
    return next.handle(request);
  }
}
